import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-back",
  "use": "rt-base-back-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-base-back\">\n<path d=\"M929.1,214.8c-17.2-40.5-41.8-77-73.2-108.3c-31.3-31.4-67.8-55.9-108.3-73.2c-42.1-17.9-86.6-27-132.4-27H295.9\n\tC288.3,6.4,285-3.3,291-8l72-55.9c15.2-11.8,18.2-35.1,6.3-50.4c-11.8-15.3-35-18.2-50.3-6.3L145.6,14.1\n\tc-18.1,14.1-18.1,42.6,0,56.7l173.3,134.7c15.7,12.2,39,8.8,50.8-7.1c11.4-15.3,8.2-37.9-6.9-49.6L291,93c-6-4.7-2.7-14.3,4.9-14.3\n\th319.3C763.3,78.5,883.8,199,883.8,347.2S763.3,615.8,615.3,615.8H202.3c-19.9,0-36.1,16.1-36.1,36.1l0,0\n\tc0,19.9,16.1,36.1,36.1,36.1h412.9c45.8,0,90.4-9,132.4-27c40.5-17.2,77-41.8,108.3-73.2c31.3-31.4,55.9-67.8,73.2-108.3\n\tC947,437.6,956,393,956,347.2S947,256.8,929.1,214.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/back.svg
// module id = 1228
// module chunks = 116